import { IsDefined, IsInt, IsNotEmpty, IsString, MaxLength, Min } from 'class-validator';

/**
 * Quantity Unit API Model
 *
 * This API model defines the data structure for quantity unit entities
 * when communicating with the API.
 */
export class QuantityUnitApiModel {
  /**
   * Numeric identifier for the quantity unit
   * Must be greater than 0
   */
  @IsInt()
  @IsDefined()
  @Min(1)
  number!: number;

  /**
   * Full name of the quantity unit
   * Maximum length: 255 characters
   */
  @IsString()
  @IsDefined()
  @MaxLength(255)
  @IsNotEmpty()
  name!: string;

  /**
   * Short abbreviation of the quantity unit
   * Maximum length: 50 characters
   */
  @IsString()
  @IsDefined()
  @IsNotEmpty()
  @MaxLength(6)
  abbreviation!: string;
}
